<template>
  <router-link
    :to="to"
    class="nav-link"
    active-class="active">
    <slot/>
    <i class="fas fa-angle-right pull-right" />
  </router-link>
</template>

<script>
export default {
  props: {
    to: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
.nav-link {
  outline: 0;
}
.nav-pills > a {
  border-radius: 2px;
  padding: 5px 15px;
}
.nav-pills > a i {
  display: none;
  line-height: 1.4em;
}
.nav-editor > a.active {
  background-color: #3a5878 !important;
}
.nav-editor > a.active i {
  display: block;
}

.nav-editor > a.active:hover,
.nav-editor > a:hover {
  background-color: #4a6888;
  color: #fff;
}
.nav-editor > a + a {
    margin-top: 2px;
    margin-left: 0;
}
</style>
